import { useState, useEffect } from 'react'
import AppointmentApiInvoker from '../../../api/AppointmentApiInvoker'
import { DriversData } from '../interfaces'
import { formatDrivers } from '../utils/driverModalUtils'
import { Driver } from '../../TransferAppointments/Traslado/EditTransferServiceDialog/interfaces'

export const useDriverSelectModal = (driverId?: Driver | null) => {
  const [selectedDriver, setSelectedDriver] = useState<Driver | null>(driverId ?? null)
  const [drivers, setDrivers] = useState<Driver[]>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const initializeDrivers = async () => {
    const driversData: DriversData = await new Promise((res) => {
      AppointmentApiInvoker.getDriverToReasing(
        '?page=0&pageSize=20',
        (data: DriversData) => res(data)
      )
    })
    if (driversData) {
      const formattedDrivers: Driver[] = formatDrivers(driversData)
      setDrivers(formattedDrivers)
    }
    setIsLoading(false)
  }

  const handleSelectDriver = (driverId: number) => {
    const driverData = drivers?.find((obj) => obj.id === driverId)
    if (driverData) {
      setSelectedDriver({ id: driverId, value: driverData?.value })
    }else {
      setSelectedDriver(null)
    }
  }

  useEffect(() => {
    initializeDrivers()
  }, [])


  return { drivers, handleSelectDriver, selectedDriver, isLoading }
}
